import { Collapse as MantineCollapse } from "@mantine/core";
import type { IProps } from "./collapse.types";
import { FunctionComponent } from "react";

/**
 * Wrapper around Mantine Collapse for consistent usage across the project.
 * @param props - Collapse component props.
 * @returns The Collapse component.
 */
const Collapse: FunctionComponent<IProps> = (props) => {
    return <MantineCollapse {...props} />;
};

export { Collapse };
